import { Injectable } from "@angular/core";

interface IKeyBooleanObject {
  [key: string]: Boolean;
}
class TemplateCache {
  templates: Object = {};

  get(key: string): any {
    return this.templates[key];
  }

  put(key: string, value: any): void {
    this.templates[key] = value;
  }
}

@Injectable({
  providedIn: 'root'
})
export class CachingUtilityService {
  private templateCache: TemplateCache;
  private templateProvidersRegistry: IKeyBooleanObject;

  constructor() {
    this.templateCache = new TemplateCache();
    // we don't want to load same templates multiple times.
    // once we load template for provider X, we put the name of that provider here
    this.templateProvidersRegistry = {};
  }

  getTemplate(key: string): string {
    return this.templateCache.get(key);
  }

  putTemplate(key: string, value: any) {
    this.templateCache.put(key, value);
  }

}
